import { ListItem, UnorderedList } from '@chakra-ui/react';
import { Alert } from '@gamma/ui/overlay';

interface StatusStringsProps {
  statusStrings: string[];
}

export const StatusStrings = ({ statusStrings }: StatusStringsProps) => {
  return (
    <Alert
      variant="subtle"
      status="warning"
      data-testid="exclude-entity-warning-alert"
    >
      {statusStrings?.length <= 1 ? (
        statusStrings[0]
      ) : (
        <UnorderedList>
          {statusStrings.map((str, idx) => (
            <ListItem data-testid={`exclude-entity-warning-list-item-${idx}`}>
              {str}
            </ListItem>
          ))}
        </UnorderedList>
      )}
    </Alert>
  );
};
